module.exports = __webpack_public_path__ + "img/icons-40-perks-we-are-flat.e8730150.svg";